import { HaldaMessageType } from "../types";

export const ignoredSentryErrors = [
  // Following error is caused by other websites trying to run "aimtell-worker.js" in our iframe.
  /https:\/\/app\.heyhalda\.com\/aimtell-worker\.js/,
  // Following error is caused by people on Safari clicking the 'x' right after clicking the
  // refresh button on Safari or mobile iOS devices, and there isn't really anything we can do to
  // recover gracefully from it since our request for the iframe is canceled.
  // See https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
  /TypeError: cancelled/,
  // This function didn't exist till after Chrome version 72.
  // A bunch of bots that are on old Chrome versions are triggering this.
  /Object.fromEntries is not a function/,
  // Caused by a bunch of bots
  /req.clone is not a function/,
  // Caused by a bunch of bots
  /^Error null$/,
  // Caused by a bunch of bots
  /^null$/,
  // Caused by a bunch of bots
  /^Error undefined$/,
  // Caused by a bunch of bots
  /^undefined$/,
  // Caused by a bunch of bots
  /globalThis is not defined/,
  // Seems to be an infrequent bug on our funnel-graph-js library's end
  /Container cannot be found \(selector: \.Funnel\)\./,
  // This function didn't exist till after Safari verison 12
  // A bunch of bots that are on old Safari versions are triggering this.
  /Can't find variable: IntersectionObserver/,
  // UET is a Microsoft Advertising value from customer websites and is attempting to inject ads in our CSFs
  /Can't find variable: UET/,
  // Add this line to ignore "Can't find variable: gtag" errors
  // TODO: Resolve this error happening on Lone Star College
  // https://halda.sentry.io/issues/?project=6005829&query=is%3Aunresolved+issue.priority%3A%5Bhigh%2C+medium%5D+gtag&referrer=issue-list&sort=freq&statsPeriod=14d&utc=true
  /Can't find variable: gtag/,
  /gtag is not defined/,
  // An error occurring on www.duq.edu from the "livechatinc.com" script on their site.
  /https:\/\/cdn\.livechatinc\.com\/tracking\.js/,
  // From the Sun Editor. It doesn't ruin the UX
  /this\._iframeAutoHeight is not a function/,
  // From the Sun Editor. It doesn't ruin the UX
  /getSelectionNode is not a function/,
  // Network issues
  /Failed to fetch/,
  /Load failed/,
  /NetworkError when attempting to fetch resource/,
  // We don't have a ResizeObserver anymore, and we still get this error. Must be from something outside our control
  /ResizeObserver loop completed with undelivered notifications/,
  // We don't have a ResizeObserver anymore, and we still get this error. Must be from something outside our control
  /Can't find variable: ResizeObserver/,
];

export const isIgnored = ({ error }: { error: string }): boolean => (
  ignoredSentryErrors.map(err => err.test(error))
    .reduce((hasMatch, current) => hasMatch || current, false)
);

export const logErrorMessage = (message: string) => {
  const error = { message };
  window.parent.postMessage({ type: HaldaMessageType.SMART_FORM_ERROR, error }, '*');
}
